import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { Holiday } from '@classes/holiday/holiday';
import { FormEditBaseComponent } from '@components/form-edit-base.component';
import { HolidaysService } from '@services/holidays.service';
import { UiService } from '@services/ui.service';
import { HolidayGroupsService } from '@services/holiday-groups.service';
import { HolidayGroup } from '@classes/holiday/holiday-group';

@Component({
  selector: 'app-holiday-edit',
  templateUrl: './holiday-edit.component.html',
  styleUrls: ['./holiday-edit.component.scss']
})
export class HolidayEditComponent extends FormEditBaseComponent implements OnInit {
  @Input() holiday: Holiday;

  holidayGroups: HolidayGroup[] = [];

  constructor(
    protected uiSrv: UiService,
    protected fb: UntypedFormBuilder,
    private holidaysSrv: HolidaysService,
    private holidayGroupsSrv: HolidayGroupsService
  ) {
    super(uiSrv, fb);
  }

  ngOnInit() {
    super.ngOnInit();
    this.initSub();
  }

  initSub(): void {
    this.isLoading = true;
    this.holidayGroupsSrv.get().subscribe(holidayGroupsFromSrv => {
      this.holidayGroups = holidayGroupsFromSrv;
      this.isLoading = false;
      this.initForm();
    });

  }

  onSubmit(): void {
    this.isLoading = true;
    if (this.holiday) {
      this.update();
    } else {
      this.create();
    }
  }

  onCancel(): void {
    this.editFinished.emit();
  }

  endForm(response: boolean) {
    if (response) {
      this.onSubmit();
    } else {
      this.onCancel();
    }
  }

  private update(): void {
    const holidayCopy: Holiday = JSON.parse(JSON.stringify(this.holiday));
    holidayCopy.description = this.editForm.value.description;
    holidayCopy.date = this.editForm.value.date;
    holidayCopy.group = this.editForm.value.group;

    this.holidaysSrv.put(holidayCopy).subscribe(() => this.isLoading = false);
  }

  private create(): void {
    this.holiday = new Holiday(
      this.editForm.value.date,
      this.editForm.value.description,
      this.editForm.value.group
    );

    this.holidaysSrv.post(this.holiday)
      .subscribe(
        () => {
          this.isLoading = false;
        },
        () => this.holiday = null
      );
  }

  private initForm(): void {
    let description = "";
    let date = null;
    let group = null;

    if (this.holiday) {
      description = this.holiday.description;
      date = this.holiday.date;
      group = this.holiday.group;
    }

    this.editForm = this.fb.group({
      date: [date, Validators.required],
      description: [description, Validators.required],
      group: [group, Validators.required],
    });
  }
}
